import { Reveal } from "@/components/site/motion";
import { Languages, UserPlus, FileUp, ScanSearch, ClipboardCheck, BrainCircuit, BookOpen, UploadCloud, CalendarClock, Building2, BadgeCheck, GraduationCap } from "lucide-react";

const STEPS = [
  { icon: Languages, label: "Select Language" },
  { icon: UserPlus, label: "Create Profile" },
  { icon: FileUp, label: "Upload Qualifications" },
  { icon: ScanSearch, label: "AI Qualification Recognition" },
  { icon: ClipboardCheck, label: "Eligibility Check" },
  { icon: BrainCircuit, label: "AI Opportunity Matching" },
  { icon: BookOpen, label: "Course Selection" },
  { icon: UploadCloud, label: "Upload Documents" },
  { icon: CalendarClock, label: "Interview Booking" },
  { icon: Building2, label: "Provider Review" },
  { icon: BadgeCheck, label: "Offer Received" },
  { icon: GraduationCap, label: "Enrolment" },
];

export const StudentJourney = () => (
  <section id="journey" data-testid="journey-section" className="relative py-28 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="max-w-2xl">
        <Reveal><p className="text-xs uppercase tracking-[0.22em] text-cobalt font-semibold">The Learner Journey</p></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-display font-extrabold tracking-tighter text-ink text-4xl sm:text-5xl leading-[0.98]">
            From first click to enrolment.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-lg leading-relaxed text-slatey">
            The end-to-end OpenDegree learner journey. Within any single application, a focused 9-stage lifecycle
            tracks its progress in the application centre.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal
            key={i}
            delay={(i % 4) * 0.05}
            className="group relative"
            data-testid={`journey-step-${i}`}
          >
            {/* connector to next (desktop) */}
            {i % 4 !== 3 && i !== STEPS.length - 1 && (
              <span className="pointer-events-none absolute left-[calc(3rem+8px)] top-6 hidden h-px w-[calc(100%-3rem)] bg-gradient-to-r from-cobalt/30 to-transparent lg:block" />
            )}
            <div className="flex items-start gap-4">
              <div className="relative flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-cobalt text-white shadow-[0_8px_20px_rgba(16,76,250,0.25)] transition-transform duration-300 group-hover:scale-105">
                <s.icon className="h-5 w-5" strokeWidth={1.9} />
                <span className="absolute -right-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full border-2 border-white bg-ink text-[11px] font-bold text-white">
                  {i + 1}
                </span>
              </div>
              <div className="pt-1">
                <p className="text-[15px] font-semibold text-ink leading-tight">{s.label}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
